export interface ReportingUnitOption {
  singular: string
  plural: string
  value: string // what gets stored in DB (the plural form)
  display_name: string // properly capitalized singular for display (e.g., "Case", "LB")
  display_name_plural: string // properly capitalized plural for display (e.g., "Cases", "LBS")
}

export const REPORTING_UNITS: ReportingUnitOption[] = [
  {
    singular: 'lb',
    plural: 'lbs',
    value: 'lbs',
    display_name: 'LB',
    display_name_plural: 'LBS',
  },
  {
    singular: 'each',
    plural: 'eaches',
    value: 'eaches',
    display_name: 'Each',
    display_name_plural: 'Eaches',
  },
  {
    singular: 'unit',
    plural: 'units',
    value: 'units',
    display_name: 'Unit',
    display_name_plural: 'Units',
  },
  {
    singular: 'item',
    plural: 'items',
    value: 'items',
    display_name: 'Item',
    display_name_plural: 'Items',
  },
  {
    singular: 'gallon',
    plural: 'gallons',
    value: 'gallons',
    display_name: 'Gallon',
    display_name_plural: 'Gallons',
  },
  {
    singular: 'oz',
    plural: 'oz',
    value: 'oz',
    display_name: 'OZ',
    display_name_plural: 'OZ',
  },
  {
    singular: 'serving',
    plural: 'servings',
    value: 'servings',
    display_name: 'Serving',
    display_name_plural: 'Servings',
  },
  {
    singular: 'liter',
    plural: 'liters',
    value: 'liters',
    display_name: 'Liter',
    display_name_plural: 'Liters',
  },
  {
    singular: 'kg',
    plural: 'kg',
    value: 'kg',
    display_name: 'KG',
    display_name_plural: 'KG',
  },
]
